module.exports = __webpack_public_path__ + "media/images/img_icon_01-97e8c36eccc36667cd686d58b650846b.png";